<ng-container *ngIf="entityType == 'EKAMPUS'">
  <app-fildarianeEKAMPUS></app-fildarianeEKAMPUS>
</ng-container>
<ng-container *ngIf="entityType == 'IP'">
  <app-fildarianeIP></app-fildarianeIP>
</ng-container>
